import { notification } from "antd";

import { reportError } from "../sentry";
import colors from "../themes/colors";
import { getServerErrorNotification } from "./error";

const notificationStyle: React.CSSProperties = {
  color: colors.purple,
  overflowY: "auto",
  whiteSpace: "pre-wrap",
  wordWrap: "break-word",
  maxHeight: "450px",
};

export const showErrorNotification = ({
  message,
  description,
}: {
  message: string;
  description?: string;
}) => {
  notification.error({
    message: message,
    description: description,
    duration: 0,
    style: notificationStyle,
  });
};

export const showInfoNotification = ({
  message,
  description,
}: {
  message: string;
  description?: string;
}) => {
  notification.info({
    message: message,
    description: description,
    duration: 0,
    style: notificationStyle,
  });
};

export const showGraphQlErrorNotification = (
  messagePrefix: string,
  error: unknown
) => {
  if (error) {
    reportError(error);
  }

  const prefix = messagePrefix.trim();
  const { message: serverMessage, description } = getServerErrorNotification(
    error,
    ""
  );
  const detail = serverMessage.trim();
  const parts = [prefix, detail].filter(Boolean);
  const message = parts.length > 0 ? parts.join(" ") : "Error";

  showErrorNotification({
    message,
    ...(description ? { description } : {}),
  });
};
